import React from 'react'
import {
    LinkBanner,
    LinkBannerProps,
} from '../../banners/LinkBanner/LinkBanner'
import { createRegisterableComponent } from '@news-mono/web-common'

export interface LinkBannerRouteProps extends LinkBannerProps {}

export const LinkBannerRegistration = createRegisterableComponent(
    'link-banner',
    (props: LinkBannerRouteProps) => <LinkBanner {...props} />,
)
